import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ThemeProvider } from './theme/ThemeContext';
import { SalaAuthProvider } from './auth/SalaAuthContext';
import './styles/global.css';
import 'katex/dist/katex.min.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <SalaAuthProvider>
          <App />
        </SalaAuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
);
